import { render, staticRenderFns } from "./workloadStatistics.vue?vue&type=template&id=73160723&scoped=true"
import script from "./workloadStatistics.vue?vue&type=script&lang=js"
export * from "./workloadStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73160723",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73160723')) {
      api.createRecord('73160723', component.options)
    } else {
      api.reload('73160723', component.options)
    }
    module.hot.accept("./workloadStatistics.vue?vue&type=template&id=73160723&scoped=true", function () {
      api.rerender('73160723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeKanban/components/workloadStatistics.vue"
export default component.exports